import dayjs from '@jobcost-monorepo/dayjs-config';
import { DatePicker } from '@jobcost-monorepo/ui';
import { isHoliday, isWeekend } from '@jobcost-monorepo/utils';
import { FC, useState } from 'react';
import HolidayModal from './HolidayModal';
import { useTranslation } from '@jobcost-monorepo/i18n';
import { useFormContext, useController } from 'react-hook-form';

const CrudDatePicker: FC = () => {
  const name = 'operationDate';
  const { t } = useTranslation();
  const [modalDate, setModalDate] = useState<Date | null>(null);
  const [isCalendarOpen, setIsCalendarOpen] = useState<boolean>(false);

  const { control } = useFormContext();
  const {
    field: { onChange },
  } = useController({ control, name });

  const onChangeDate = (date: Date) => {
    if (isWeekend(date) || isHoliday(date)) {
      setModalDate(date);
      setIsCalendarOpen(false);
      return true;
    }
    return false;
  };

  const handleConfirmDate = () => {
    if (modalDate) {
      onChange(dayjs(modalDate).format('YYYY-MM-DD'));
    }
    setModalDate(null);
  };

  const handleCloseModal = () => {
    setModalDate(null);
    setIsCalendarOpen(true);
  };

  return (
    <>
      <DatePicker
        name={name}
        errorName="operationDate"
        label={t('form.operationDate', { ns: 'timesheets' })}
        onChangeDate={onChangeDate}
        isCalendarOpen={isCalendarOpen}
        setIsCalendarOpen={setIsCalendarOpen}
      />
      <HolidayModal
        modalDate={modalDate}
        handleCloseModal={handleCloseModal}
        handleConfirmDate={handleConfirmDate}
      />
    </>
  );
};

export default CrudDatePicker;
